import { useAppContext } from '@/hooks/useAppContext';
import { RelayList } from './RelayList';

/** Shared site footer with the relay list and the "Vibed with Shakespeare" link. */
export function ForumFooter() {
  const { config } = useAppContext();
  const writeCount = config.relayMetadata.relays.filter((r) => r.write).length;

  return (
    <footer className="mt-10 space-y-4 border-t border-[#d6d6d6] pt-4">
      <div className="rounded-[6px] border border-[#d6d6d6] bg-white px-4 py-3">
        <RelayList />
      </div>
      <div className="text-center text-xs text-[#888]">
        <p>Decentralized forum · Nostr kind 32323 · sending to {writeCount} relay{writeCount === 1 ? '' : 's'}</p>
        <p className="mt-1">
          <a
            href="https://shakespeare.diy"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#105B86] hover:underline"
          >
            Vibed with Shakespeare
          </a>
        </p>
      </div>
    </footer>
  );
}
